export default "__VITE_ASSET__Oo11rAfq__"